import React, { useState, useEffect } from 'react';
import ActiveTrades from './ActiveTrades';
import CompletedTrades from './CompletedTrades'
import AllocationChanges from './AllocationChanges'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import BonusTradesOverview from './BonusTradesOverview';
import SneakPeek from './SneakPeek';
import Scalper from './Scalper';
import CompositeTrades from './CompositeTrades';

function Trades(props) {

    let { activeTab } = useParams();

    const [tab, setTab] = useState(activeTab ? activeTab : 'active');
    const [brokerageConnections, setBrokerageConnections] = useState([]);

    useEffect(() => {
        (async function () {

            async function loadBrokerageConnections() {
                console.log("Checking for active brokerage connections");
                let response = await fetch(`/api/brokeragesActive?userId=` + props.userId);
                if (response.ok) {
                    let connections = await (response.json());
                    setBrokerageConnections(connections);
                }
            }
            loadBrokerageConnections();
        })();
    }, [props.userId]);


    function shouldAllow() {
        return (props.role >= 0);
    }

    const handleChangeTab = (event, newTab) => {
        setTab(newTab);
    };


    return (
        <div>
            {shouldAllow() ?
                <>
                    <Box sx={{ bgcolor: '#F0F0F0', border: 1, borderBottom: 0, borderColor: 'black', borderRadius: 0 }}>
                        <Tabs
                            value={tab}
                            onChange={handleChangeTab}
                            textColor="secondary"
                            indicatorColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="active" label="Active" href="/trades/active" />
                            <Tab value="completed" label="Completed" href="/trades/completed" />
                            <Tab value="history" label="Trade History" href="/trades/history" />
                            <Tab value="sneakpeek" label="Sneak Peek" href="/trades/sneakpeek" />
                            <Tab value="bonus" label="Bonus Trades" href="/trades/bonus" />
                            <Tab value="options" label="Options" href="/trades/options" />
                            <Tab value="composite" label="Composite" href="/trades/composite" />
                        </Tabs>
                    </Box>
                    <br></br>

                    {tab === "active" ?
                        <>
                            <ActiveTrades role={props.role} onlyShowUserTrades={props.isOptions} userId={props.userId} accountId={props.accountId} planId={props.planId} mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} accountValue={props.accountValue} />
                        </>
                        : null}
                    {tab === "completed" ?
                        <>
                            <CompletedTrades role={props.role} onlyShowUserTrades={props.isOptions} userId={props.userId} accountId={props.accountId} mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} planId={props.planId} />
                        </>
                        : null}
                    {tab === "history" ?
                        <>
                            <AllocationChanges mobileView={props.mobileView} onAlgoSelected={props.onAlgoSelected} planId={props.planId} accountValue={props.accountValue} />
                        </>
                        : null}
                    {tab === "sneakpeek" ?
                        <>
                            <SneakPeek mobileView={props.mobileView} planId={props.planId} role={props.role} />
                        </>
                        : null}

                    {tab === "options" && brokerageConnections && brokerageConnections.length ?
                        <>
                            <Scalper mobileView={props.mobileView} planId={props.planId} userId={props.userId} brokerage="schwab" accountId={props.accountId} />
                        </>
                        : null}

                    {tab === "bonus" ?
                        <>
                            <BonusTradesOverview brokerageConnections={brokerageConnections} mobileView={props.mobileView} userId={props.userId} accountValue={props.accountValue} accountId={props.accountId} role={props.role} onAlgoSelected={props.onAlgoSelected} />
                        </>
                        : null}
                    {tab === "composite" ?
                        <>
                            <CompositeTrades brokerageConnections={brokerageConnections} mobileView={props.mobileView} userId={props.userId} accountValue={props.accountValue} accountId={props.accountId} role={props.role} onAlgoSelected={props.onAlgoSelected} />
                        </>
                        : null}

                </>
                :
                <div class="empty-page" >Not allowed</div>
            }


        </div>
    );
}

export default Trades;